import type {
  DropdownSelectSearchProps,
  InputFieldClearButtonData,
  SelectOption,
} from '@presentation/components';
import type { InputProps } from '@presentation/components/Input/types';

export interface InputSelectFieldProps<TValue> extends Omit<InputProps, 'onSelect'> {
  name: string;
  options: SelectOption<TValue>[];
  dismissOnClick?: boolean;
  onSelect?: DropdownSelectSearchProps<TValue>['onSelect'];
  clearButton?: InputFieldClearButtonData<TValue>;
  useSearch?: boolean;
  noEmpty?: boolean;
  dropdownProps?: DropdownSelectSearchProps<TValue>;
  sortBySelected?: boolean;
  hasDropdownIcon?: boolean;
  alwaysTreatAsArray?: boolean;
  disableErrors?: boolean;
}
